module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4n8n7r-e197e01fc3c278435ee501c98d12a87b.svg";